import { action } from 'satcheljs';

/**
 * action for loading the Automatic replies banner option
 */
const loadAutomaticRepliesBannerOptions = action('loadAutomaticRepliesBannerOptions');

export default loadAutomaticRepliesBannerOptions;
